module.exports = "./img/835923b7fa5298c44f7087e523d7793e.jpg";